module.exports = __webpack_public_path__ + "media/images/young_pin_design_award-s@2x-a9c557ed20549a013f32bec3644da5ae.png";